<div echarts [options]="adaptedOptions()" [initOpts]="initOpts" class="deviation-plot-chart"></div>
